import apiAction from 'common/redux/actions/apiAction';
import { POST_UNIVERSAL_DASHBOARD_URL } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const initiateUniversalDashboardTransfer = (data) => {
  return {
    type: 'POST_UNIVERSAL_DASHBOARD_DATA',
    payload: data,
  };
};

export const TransferUniversalDashboardData = (configParams) => {
  return apiAction.postAPI({
    url: POST_UNIVERSAL_DASHBOARD_URL(configParams.apiType, configParams.apiSubType),
    data: configParams,
    onSuccess: initiateUniversalDashboardTransfer,
    onFailure: (err) => logError('Error occured while connecting dashboard API:', err),
    label: 'SET_UNIVERSAL_DASHBOARD_DATA',
  });
};
